<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M32 5A22.52 22.52 0 009.5 27.5c0 11.24 17.63 27.65 21.17 30.83a2 2 0 001.33.5 2 2 0 001.33-.51C36.87 55.15 54.5 38.74 54.5 27.5A22.52 22.52 0 0032 5zm0 50.48C28.12 51.91 12.5 37 12.5 27.5a19.5 19.5 0 0139 0c0 9.5-15.62 24.41-19.5 27.98z"/><path d="M33.41 16.91a2 2 0 00-2.82 0L20.41 27.09a2 2 0 001.42 3.41h20.34a2 2 0 001.42-3.41z"/></svg>